var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import InlineError from "../../../../UI/InlineError";
import { IconButton, Button, Modal, SubmitButton, Form, DotsLoader } from "@brushfire/ui";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
var ClearCartButton = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.isClearCart, isClearCart = _b === void 0 ? true : _b, setShowRemoveAttendeeModal = _a.setShowRemoveAttendeeModal, attendeeId = _a.attendeeId, clearAllAttendeesAndAddons = _a.clearAllAttendeesAndAddons, subject = _a.subject;
    var _c = __read(useState(false), 2), showPopover = _c[0], setShowPopover = _c[1];
    var clearCartRef = useRef(null);
    var _d = __read(useState(false), 2), isDeleted = _d[0], setIsDeleted = _d[1];
    return (_jsxs("div", __assign({ onClick: function (evt) {
            evt.stopPropagation();
        } }, { children: [isClearCart ? (_jsx("button", __assign({ className: "btn btn-dark cart-btn btn-xs link-btn clear", onClick: function (evt) {
                    evt.stopPropagation();
                    if (!isClearCart && setShowRemoveAttendeeModal && attendeeId) {
                        setShowRemoveAttendeeModal(attendeeId);
                    }
                    setShowPopover(true);
                } }, { children: "Clear Cart" }))) : (_jsx(IconButton, { classes: "box-shadow-focus-none", ref: clearCartRef, icon: "trash-alt", ariaLabel: "Clear Cart", onClick: function (evt) {
                    evt.stopPropagation();
                    if (!isClearCart && setShowRemoveAttendeeModal && attendeeId) {
                        setShowRemoveAttendeeModal(attendeeId);
                    }
                    setShowPopover(true);
                }, busy: isDeleted, customBusyIcon: _jsx(DotsLoader, { classes: "dots-iconButton btn-spinner" }) })), _jsxs(Modal, __assign({ closeButton: false, size: "sm", show: showPopover, setShow: setShowPopover }, { children: [_jsx(InlineError, { id: "clearCartError" }), _jsx(Form, __assign({ onSubmit: function (values, formikHelpers) {
                            setIsDeleted(true);
                            onSubmit(values, formikHelpers);
                            if (isClearCart) {
                                setTimeout(function () {
                                    setShowPopover(false);
                                    setIsDeleted(false);
                                }, 3000);
                            }
                        }, initialValues: {}, useUnsavedPrompt: false }, { children: function (_a) {
                            var formikContext = _a.formikContext;
                            return (_jsxs(WidgetFieldset, { children: [_jsx("h6", __assign({ className: "ta-center" }, { children: clearAllAttendeesAndAddons
                                            ? "Are you sure you want to remove this attendee and all items?"
                                            : isClearCart
                                                ? "Are you sure you want to remove all ".concat(subject, "s?")
                                                : "Are you sure you want to remove this ".concat(subject, "?") })), _jsxs("div", __assign({ className: "modal-footer border-0 p-0 p-top" }, { children: [_jsx(SubmitButton, __assign({ component: Button, type: "submit", purpose: "danger", customBusyIcon: _jsx(DotsLoader, { classes: "dots-button btn-spinner white" }), classes: "btn-sm btn-block p-0 m-0" }, { children: isClearCart || clearAllAttendeesAndAddons ? "Clear Cart" : "Remove" })), _jsx(Button, __assign({ busy: false, type: "button", purpose: "plain", onClick: function () { return setShowPopover(false); }, classes: "btn-block clear-cart-cancel" }, { children: _jsx("small", { children: "Cancel" }) }))] }))] }));
                        } }))] }))] })));
};
export default ClearCartButton;
